import { render } from "./HeroiconsSolidStar.vue?vue&type=template&id=c95b231a"
const script = {}

import exportComponent from "/home/nginx/domains/panel.vip-mod.net/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidStar.vue"]])

export default __exports__